import { gql } from '~src/generated/portal/gql';

const CREATE_API_TEST_PLAN_FROM_GOLD_STANDARD = gql(`
  mutation createAPITestPlanFromGoldStandard($input: CreateAPITestPlanFromGoldStandardInput!) {
    createAPITestPlanFromGoldStandard(input: $input) {
      id
      name
      description
      partnerId
      providerId
      minApiVersion {
        version
      }
      platform {
        platform
      }
      environment
    }
  }
`);
export default CREATE_API_TEST_PLAN_FROM_GOLD_STANDARD;
